import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom'; // Ensure correct import
import Navbar from '../home/Navbar';
import Queryform from './Queryform';
import Footer from '../home/Footer';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { API_END_POINT } from './Utils/Constant';
import axios from 'axios';

const KundliResult = () => {
  const location = useLocation();
  // Accessing the planets data directly from location state
  const kundliData = location.state?.kundliData;

  // Get the divisional chart image URL
  const divisionalChartImageUrl = kundliData.divisionalChartImageUrl;
  // Ensure we have data in kundliData
  // console.log("kundli data :", kundliData); // Check if data is available
  // console.log("Data :", kundliData?.data?.response);
  // State for the divisional chart image URL
  //const [divisionalChartImageUrl, setDivisionalChartImageUrl] = useState(null);

  const kundliRef = useRef(null);

  const handleDownloadPDF = async () => {
    const input = kundliRef.current;

    // Scroll to top to avoid partial capture
    window.scrollTo(0, 0);

    // Take screenshot of full content
    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      windowWidth: document.documentElement.scrollWidth,
      windowHeight: document.documentElement.scrollHeight
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.9);
    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const imgProps = {
      width: canvas.width,
      height: canvas.height
    };

    const pdf = new jsPDF("p", "mm", "a4");

    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save("kundli-result.pdf");
  };


  if (!kundliData) {
    return (
      <div className="text-center py-10">
        <h2 className="text-lg text-red-500">No data available!</h2>
      </div>
    );
  }

  const handleSaveKundliDetails = async () => {
    try {
      // Fetch user profile from the API to get userId
      const userProfileResponse = await axios.get(`${API_END_POINT}user/profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`, // Include authToken in headers
        },
      });

      // Extract userId from the API response
      const userProfile = userProfileResponse.data;
      const userId = userProfile?.userId; // Adjust based on the API response structure

      if (!userId) {
        alert("User ID not found. Please log in.");
        return;
      }

      // Include the user ID in the payload
      const payload = {
        userId,
        ...kundliData,
      };

      console.log("Payload being sent to backend:", payload); // Log the payload for debugging
      // Send the payload to the backend
      const response = await axios.post(`${API_END_POINT}kundli/save-kundli`, payload);
      alert("Kundli details saved successfully");
    } catch (error) {
      console.error('Error saving kundli details:', error);
      alert("Failed to save Kundli details. Please try again.");
    }
  };

  // Helper function to extract userId from authToken (if it's a JWT)
  const extractUserIdFromAuthToken = (authToken) => {
    try {
      const payload = JSON.parse(atob(authToken.split('.')[1])); // Decode JWT payload
      return payload?.userId; // Adjust based on your token structure
    } catch (error) {
      console.error('Error decoding authToken:', error);
      return null;
    }
  };

  // Extracting ascendantData and personalDetails
  const ascendantData = kundliData.ascendantData?.data?.[0]; 
  const personalDetails = kundliData.personalDetails?.data; 

  return (
    <section className="bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen">
      <Navbar />
      <div ref={kundliRef} className="px-4 sm:px-8 md:px-16 lg:px-32 mt-8">
        <h1 className="text-3xl sm:text-4xl font-serif font-bold text-secondary text-center">Kundli Prediction</h1>
        {/* kundli chart  */}
        <div>
          {/* Display Divisional Chart Image */}
          {/* <div className="mt-8 bg-gray-50 p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold text-center text-primary mb-4">Divisional Chart</h2>
          {divisionalChartImageUrl ? (
            <div className="flex justify-center">
              <img
                src={divisionalChartImageUrl}
                alt="Divisional Chart"
                className="max-w-xs rounded-lg shadow-md"
                style={{
                  width: '300px',
                  height: 'auto',
                  backgroundColor: '#fff',
                  padding: '10px',
                  borderRadius: '10px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                }}
              />
            </div>
          ) : (
            <p className="text-center text-red-500 font-semibold">Failed to load divisional chart image.</p>
          )}
        </div> */}
        </div>
        {/* Table Container for Planet Data */}
        <div className="overflow-x-auto mt-8 bg-white shadow-md rounded-lg p-6">
          <Table className="min-w-full text-center border-collapse">
            <Thead>
              <Tr className="bg-gradient-to-r from-success to-[#9034E9] text-white">
                <Th className="px-4 py-2 border">Planet</Th>
                <Th className="px-4 py-2 border">Full Name</Th>
                <Th className="px-4 py-2 border">Zodiac</Th>
                <Th className="px-4 py-2 border">House</Th>
                <Th className="px-4 py-2 border">Nakshatra</Th>
                <Th className="px-4 py-2 border">Nakshatra Lord</Th>
                <Th className="px-4 py-2 border">Retrograde</Th>
                <Th className="px-4 py-2 border">Avastha</Th>
                <Th className="px-4 py-2 border">Lord Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {/* Display only the first 10 planets */}
              {Object.values(kundliData?.planetsData?.data || {}).slice(0, 10).map((planet, index) => {
                // Add different colors based on conditions
                let rowColor = "bg-white"; 
                if (planet.retro) {
                  rowColor = "bg-yellow-200"; // Retrograde planets in yellow
                } else if (planet.zodiac === "Aquarius") {
                  rowColor = "bg-blue-200"; 
                } else if (planet.zodiac === "Sagittarius") {
                  rowColor = "bg-orange-100"; 
                }

                return (
                  <Tr key={index} className={`hover:bg-gray-100 ${rowColor}`}>
                    <Td className="px-4 py-2 border">{planet.name}</Td>
                    <Td className="px-4 py-2 border">{planet.full_name}</Td>
                    <Td className="px-4 py-2 border">{planet.zodiac}</Td>
                    <Td className="px-4 py-2 border">{planet.house}</Td>
                    <Td className="px-4 py-2 border">{planet.nakshatra}</Td>
                    <Td className="px-4 py-2 border">{planet.nakshatra_lord}</Td>
                    <Td className="px-4 py-2 border">{planet.retro ? "Yes" : "No"}</Td>
                    <Td className="px-4 py-2 border">{planet.basic_avastha}</Td>
                    <Td className="px-4 py-2 border">{planet.lord_status}</Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </div>

        {/* Additional Kundli Details */}
        <div className="mt-8 bg-slate-200 p-5 rounded-md shadow-md">
          <h2 className="text-2xl font-bold text-center text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-1 mb-4">Additional Information</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 items-center text-center gap-6">
            <div className="bg-[#80ecec] flex gap-1 justify-center shadow-md rounded-lg p-4">
              <h3 className="font-semibold text-gray-800">Birth Dasa:</h3>
              <p>{kundliData?.planetsData?.data.birth_dasa}</p>
            </div>
            <div className="bg-[#e7ad9c] flex gap-1 justify-center shadow-md rounded-lg p-4">
              <h3 className="font-semibold text-gray-800">Current Dasa:</h3>
              <p>{kundliData?.planetsData?.data.current_dasa}</p>
            </div>
            <div className="bg-[#feeaa6] flex gap-1 justify-center shadow-md rounded-lg p-4">
              <h3 className="font-semibold text-gray-800">Lucky Gem:</h3>
              <p>{kundliData?.planetsData?.data.lucky_gem?.join(", ")}</p>
            </div>
            <div className="bg-[#7dead3] flex gap-1 justify-center shadow-md rounded-lg p-4">
              <h3 className="font-semibold text-gray-800">Lucky Number:</h3>
              <p>{kundliData?.planetsData?.data.lucky_num?.join(", ")}</p>
            </div>
            <div className="bg-[#fdca6e] flex gap-1 justify-center shadow-md rounded-lg p-4">
              <h3 className="font-semibold text-gray-800">Lucky Colors:</h3>
              <p>{kundliData?.planetsData?.data.lucky_colors?.join(", ")}</p>
            </div>
            <div className="bg-[#54eec3] flex gap-1 justify-center shadow-md rounded-lg p-4">
              <h3 className="font-semibold text-gray-800">Lucky Letters:</h3>
              <p>{kundliData?.planetsData?.data.lucky_letters?.join(", ")}</p>
            </div>
            <div className="bg-[#b5aefc] flex gap-1 justify-center shadow-md rounded-lg p-4">
              <h3 className="font-semibold text-gray-800">Lucky Name Starts:</h3>
              <p>{kundliData?.planetsData?.data.lucky_name_start?.join(", ")}</p>
            </div>
            <div className="bg-green-300 flex gap-1 justify-center shadow-md rounded-lg p-4">
              <h3 className="font-semibold text-gray-800">Rasi:</h3>
              <p>{kundliData?.planetsData?.data.rasi}</p>
            </div>
            <div className="bg-[#ffb6b5] flex gap-1 justify-center shadow-md rounded-lg p-4">
              <h3 className="font-semibold text-gray-800">Nakshatra:</h3>
              <p>{kundliData?.planetsData?.data.nakshatra}</p>
            </div>
          </div>
        </div>

        {/* Panchang and Ghatka Chakra Details (Flex Row) */}
        <div className="flex w-full flex-row mt-8 gap-6">
          {/* Panchang Details */}
          <div className="bg-slate-200 w-1/2 shadow-md rounded-lg p-6 sm:w-1/2 lg:w-1/2">
            <h2 className="text-xl font-bold text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-1 text-center mb-4">Panchang Details</h2>
            <div className='flex gap-1 '>
              <h3 className="font-semibold text-gray-800">Ayanamsa Name:</h3>
              <p>{kundliData?.planetsData?.data.panchang?.ayanamsa_name}</p>
            </div>
            <div className='flex gap-1 '>
              <h3 className="font-semibold text-gray-800">Day of Birth:</h3>
              <p>{kundliData?.planetsData?.data.panchang?.day_of_birth}</p>
            </div>
            <div className='flex gap-1 1'>
              <h3 className="font-semibold text-gray-800">Sunrise at Birth:</h3>
              <p>{kundliData?.planetsData?.data.panchang?.sunrise_at_birth}</p>
            </div>
            <div className='flex gap-1'>
              <h3 className="font-semibold text-gray-800">Sunset at Birth:</h3>
              <p>{kundliData?.planetsData?.data.panchang?.sunset_at_birth}</p>
            </div>
          </div>

          {/* Ghatka Chakra Details */}
          <div className="bg-slate-200 w-1/2 shadow-md rounded-lg p-6 h-fit sm:w-1/2 lg:w-1/2">
            <h2 className="text-xl font-bold text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-1 text-center mb-4">Ghatka Chakra Details</h2>
            <div className='flex gap-1 '>
              <h3 className="font-semibold text-gray-800">Rasi:</h3>
              <p>{kundliData?.planetsData?.data.ghatka_chakra?.rasi}</p>
            </div>

            <div className='flex gap-1 '>
              <h3 className="font-semibold text-gray-800">Day:</h3>
              <p>{kundliData?.planetsData?.data.ghatka_chakra?.day}</p>
            </div>
            <div className='flex gap-1 '>
              <h3 className="font-semibold text-gray-800">Nakshatra:</h3>
              <p>{kundliData?.planetsData?.data.ghatka_chakra?.nakshatra}</p>
            </div>
            <div className='flex gap-1 '>
              <h3 className="font-semibold text-gray-800">Tatva:</h3>
              <p>{kundliData?.planetsData?.data.ghatka_chakra?.tatva}</p>
            </div>
            <div className='flex gap-1 '>
              <h3 className="font-semibold text-gray-800">Lord:</h3>
              <p>{kundliData?.planetsData?.data.ghatka_chakra?.lord}</p>
            </div>
          </div>
        </div>
        {/* Ascendant Report Section */}
        {ascendantData && (
          <div className="mt-8 bg-slate-200 p-5 rounded-md shadow-md">
            <h2 className="text-2xl font-bold text-center text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-1 mb-4">Ascendant Report</h2>
            <div className="grid grid-cols-1 sm:grid-cols-1 gap-6">
              <div className="flex flex-col bg-white text-center items-center p-4 shadow-md rounded-lg">
                <div className='flex gap-1'>
                  <h3 className="font-semibold text-gray-800">Ascendant:</h3>
                  <p>{ascendantData.ascendant}</p>
                </div>
                <div className='flex gap-1'>
                  <h3 className="font-semibold text-gray-800">Ascendant Lord:</h3>
                  <p>{ascendantData.ascendant_lord}</p>
                </div>
                <div className='flex gap-1'>
                  <h3 className="font-semibold text-gray-800">Ascendant Location:</h3>
                  <p>{ascendantData.ascendant_lord_location}</p>
                </div>
                <div className='flex gap-1'>
                  <h3 className="font-semibold text-gray-800">Ascendant Lord Strength:</h3>
                  <p>{ascendantData.ascendant_lord_strength}</p>
                </div>
              </div>
              <div className="flex flex-col bg-white p-4 text-center shadow-md rounded-lg">
                <h3 className="font-semibold text-white bg-gradient-to-r from-success to-[#9034E9] text-center p-1 rounded-md mb-1">General Prediction</h3>
                <p>{ascendantData.general_prediction}</p>
              </div>
              <div className="flex flex-col bg-white p-4 text-center shadow-md rounded-lg">
                <h3 className="font-semibold text-white bg-gradient-to-r from-success to-[#9034E9] text-center p-1 rounded-md mb-1">Personalised Prediction</h3>
                <p>{ascendantData.personalised_prediction}</p>
              </div>
              {/* table for ascendant data */}
              <div className="bg-white p-4 text-justify shadow-md rounded-lg">
                <Table className="table-auto w-full text-left text-gray-800">
                  <Tbody>
                    <Tr>
                      <Th className="font-semibold pr-4">Symbol:</Th>
                      <Td>{ascendantData.symbol}</Td>
                    </Tr>
                    <Tr>
                      <Th className="font-semibold pr-4">Lucky Gem:</Th>
                      <Td>{ascendantData.lucky_gem}</Td>
                    </Tr>
                    <Tr>
                      <Th className="font-semibold pr-4">Day For Fasting:</Th>
                      <Td>{ascendantData.day_for_fasting}</Td>
                    </Tr>
                    <Tr>
                      <Th className="font-semibold pr-4">Zodiac Character:</Th>
                      <Td>{ascendantData.zodiac_characteristics}</Td>
                    </Tr>
                    <Tr>
                      <Th className="font-semibold pr-4">Verbal Location:</Th>
                      <Td>{ascendantData.verbal_location}</Td>
                    </Tr>
                  </Tbody>
                </Table>
              </div>

              <div className="flex gap-1 bg-white p-4 shadow-md rounded-lg">
                <h3 className="font-semibold text-gray-800">Good Qualities:</h3>
                <p>{ascendantData.good_qualities}</p>
              </div>
              <div className="flex gap-1 bg-white p-4 shadow-md rounded-lg">
                <h3 className="font-semibold text-gray-800">Bad Qualities:</h3>
                <p>{ascendantData.bad_qualities}</p>
              </div>
              <div className="flex gap-1 bg-[#fdca6e] p-4 shadow-md rounded-lg">
                <h3 className="font-semibold text-gray-800">Gayatri Mantra:</h3>
                <p>{ascendantData.gayatri_mantra}</p>
              </div>
              <div className="flex flex-col bg-white p-4 shadow-md rounded-lg">
                <h3 className="font-semibold text-gray-800">Flagship Qualities:</h3>
                <p>{ascendantData.flagship_qualities}</p>
              </div>
              <div className="flex gap-1 bg-white p-4 shadow-md rounded-lg">
                <h3 className="font-semibold text-gray-800">Spirituality Advice:</h3>
                <p>{ascendantData.spirituality_advice}</p>
              </div>
              <div className="flex gap-1 bg-white p-4 shadow-md rounded-lg">
                <h3 className="font-semibold text-gray-800">Good Qualities:</h3>
                <p>{ascendantData.good_qualities}</p>
              </div>
              <div className="flex gap-1 bg-white p-4 shadow-md rounded-lg">
                <h3 className="font-semibold text-gray-800">Bad Qualities:</h3>
                <p>{ascendantData.bad_qualities}</p>
              </div>
            </div>
          </div>
        )}

        {/* Personal Details Section */}
        {personalDetails && (
          <div className="mt-8 bg-slate-200 p-5 rounded-md shadow-md">
            <h2 className="text-2xl font-bold text-center text-white bg-gradient-to-r from-success to-[#9034E9] rounded-md p-1 mb-4">Personal Details</h2>
            {personalDetails.map((detail, index) => (
              <div key={index} className="bg-gray-100 p-4 shadow-md rounded-lg mb-4">
                <h3 className="font-semibold text-white bg-gradient-to-r from-success to-[#9034E9] text-center p-1 rounded-md text-lg">Current House: {detail.current_house}</h3>
                <h3 className="font-semibold text-gray-800 mt-1">Location: {detail.verbal_location}</h3>
                <p><strong>Zodiac: </strong>{detail.current_zodiac}</p>
                <p><strong>Lord Zodiac: </strong>{detail.lord_of_zodiac}</p>
                <p><strong>Lord Zodiac Location: </strong>{detail.lord_zodiac_location}</p>
                <p><strong>Lord House Location: </strong>{detail.lord_house_location}</p>
                <p><strong>Personalised Prediction: </strong>{detail.personalised_prediction}</p>
              </div>
            ))}
            {/* watermark for kundli pdf */}
            <div className='opacity-50 mt-2 mb-0 '>
              <h2 className='text-lg font-bold text-center text-gray-800'>Kundli Report Generated By AstroTellers</h2>
            </div>
          </div>
        )}
      </div>
      {/* button to save kundli details */}
      <div class=' w-full flex justify-center mt-8'>
        <button onClick={handleSaveKundliDetails} class='bg-gray-900 hover:bg-secondary transition-all duration-300 text-white w-1/2 py-2 rounded-md' >Save my Kundli details</button>
      </div>
      {/* button to download kundli details */}
      <div className=' w-full flex justify-center mt-8'>
        <button className='bg-gray-900 hover:bg-secondary transition-all duration-300 text-white w-1/2 py-2 rounded-md' onClick={handleDownloadPDF}>Download Kundli Details</button>
      </div>
      <Queryform />
      <Footer />
    </section>
  );
};

export default KundliResult;